import { combineReducers } from "redux";

import { menuItemReducer } from "../components/theme/sidebar/Menu/reducers";

import { loadingReducer, apiKeyReducer } from "../components/theme/reducers";
import {
  baseProductNameReducer,
  productBaseBarcodeReducer,
  productBaseCostReducer,
  productBaseInternalCodeReducer,
  productBasePriceReducer,
  productsListReducer,
  baseProductInitialStockReducer,
  unitsReducer,
  unitReducer,
  categoryReducer,
  categoriesReducer,
  maskPriceReducer,
  maskCostReducer
} from "../components/pages/products/base/reducers";

import {
  currentBranchReducer,
  branchesReducer
} from "../components/pages/branches/reducers";

import {
  cityLocationReducer,
  complementReducer,
  districReducer,
  postalCodeReducer,
  stateLocationReducer,
  streetNumberReducer,
  streetReducer
} from "../components/parts/address-component/reducers";

import {
  ncmReducer,
  cestReducer,
  cfopReducer,
  icmsReducer,
  ncmDataReducer,
  cestDataReducer,
  cfopDataReducer,
  icmsDataReducer,
  ipiDataReducer,
  pisDataReducer
} from "../components/pages/fiscal/taxes/reducers";

import {
  basePersonNameReducer,
  basenPersonEmailReducer,
  basePersonPhoneReducer
} from "../components/parts/base-person/reducers";

import { personTypeReducer } from "../components/parts/person-type-component/reducers";
import { perdonDocReducer } from "../components/parts/document-component/reducers";
import {
  FancyNameReducer,
  FancyCRTReducer,
  cnaeReducer,
  stateRegistryReducer,
  municipalRegistryReducer,
  ieIndicatorReducer
} from "../components/parts/company-data/reducers";

import {
  stepReducer,
  isFiscalReducer
} from "../components/pages/branches/create/steps/reducers";

import { supplierReducer, suppliersReducer } from "../components/pages/products/suppliers/reducers";

import {nfseItemsReducer, nfseServiceReducer, nfseRpsReducer, nfseTakerReducer} from '../components/pages/fiscal/nfse/reducers'


const rootreducer = combineReducers({
  loading: loadingReducer,
  apiKey: apiKeyReducer,
  menuItemSelect: menuItemReducer,

  baseProductBarcode: productBaseBarcodeReducer,
  baseProductName: baseProductNameReducer,
  baseProductInternalCode: productBaseInternalCodeReducer,
  baseProductCost: productBaseCostReducer,
  baseProductPrice: productBasePriceReducer,
  products: productsListReducer,
  initialStock: baseProductInitialStockReducer,
  maskPrice: maskPriceReducer,
  maskCost: maskCostReducer,
  category: categoryReducer,
  categories: categoriesReducer,
  supplier: supplierReducer,
  suppliers: suppliersReducer,

  basePersonName: basePersonNameReducer,
  basePersonEmail: basenPersonEmailReducer,
  basePersonPhone: basePersonPhoneReducer,

  //address reducers

  cityLocation: cityLocationReducer,
  complement: complementReducer,
  district: districReducer,
  postalCode: postalCodeReducer,
  stateLocation: stateLocationReducer,
  streetNumber: streetNumberReducer,
  street: streetReducer,

  fancyName: FancyNameReducer,
  crt: FancyCRTReducer,
  cnae: cnaeReducer,
  stateRegistry: stateRegistryReducer,
  ieIndicator: ieIndicatorReducer,
  municipalRegistry: municipalRegistryReducer,
  personType: personTypeReducer,
  personDoc: perdonDocReducer,

  units: unitsReducer,
  unit: unitReducer,

  //branch reducers
  currentBranch: currentBranchReducer,
  branches: branchesReducer,
  //FISCAL

  ncm: ncmReducer,
  cest: cestReducer,
  cfop: cfopReducer,
  icms: icmsReducer,
  ipi: ipiDataReducer,
  pis: pisDataReducer,

  ncmData: ncmDataReducer,
  cestData: cestDataReducer,
  cfopData: cfopDataReducer,
  icmsData: icmsDataReducer,
  //NFSE
  nfseRps: nfseRpsReducer, 
  nfseTaker: nfseTakerReducer,
  nfseService: nfseServiceReducer, 
  nfseItems: nfseItemsReducer, 

  step: stepReducer,
  isFiscal: isFiscalReducer,

});

export default rootreducer;



// WEBPACK FOOTER //
// ./src/reducers/index.jsx